import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Function to set draggable="false" on all images and videos
function preventMediaDragging() {
  // Set the attribute on all current images and videos
  document.querySelectorAll("img, video").forEach((el) => {
    el.setAttribute("draggable", "false");
    el.classList.add("no-drag");
  });

  // Create a MutationObserver to handle dynamically added elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          // Check the node itself
          if (node.nodeName === "IMG" || node.nodeName === "VIDEO") {
            (node as HTMLElement).setAttribute("draggable", "false");
            (node as HTMLElement).classList.add("no-drag");
          }

          // Check any img/video children
          (node as HTMLElement)
            .querySelectorAll?.("img, video")
            ?.forEach((el) => {
              el.setAttribute("draggable", "false");
              el.classList.add("no-drag");
            });
        }
      });
    });
  });

  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Execute after component mounts
function AppWithNoDrag() {
  useEffect(() => {
    preventMediaDragging();
  }, []);

  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppWithNoDrag />
  </StrictMode>
);
